import React, { useState } from "react"
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom"

import "./App.less"
import { getUser } from "./utils/auth"
import { DefaultLayout } from "./layouts/default"
import AppContext from "./utils/context"
import Login from "./pages/Login"
import NotFound from "./pages/NotFound"
import Unauthorized from "./pages/Unauthorized"
import { AdminLayout } from "./layouts/admin"
import { ProtectedPage } from "./components/custom"
import { dashboardRoutes, adminRoutes } from "./routes"
import Logout from "./pages/Logout"
import GlobalLoading from "./components/custom/GlobalLoading"
import Profile from "./pages/dashboard/user/Profile"

function App() {
  const [user, setUser] = useState(getUser())
  const [year, setYear] = useState("2021")
  const [month, setMonth] = useState("1")
  const [shopCode, setShopCode] = useState("001")
  const [brand, setBrand] = useState("")
  const [productCode, setProductCode] = useState("")

  return (
    <AppContext.Provider
      value={{ user, setUser, year, setYear, month, setMonth, shopCode, setShopCode, brand, setBrand, productCode, setProductCode }}
    >
      <BrowserRouter>
        <div className="App">
          <Routes>
            <Route key="/" path="/" element={<DefaultLayout />}>
              {dashboardRoutes.map(({ element: Element, path, roles, usertype, ...routeProps }) => {
                return <Route key={path} exact path={path} element={<ProtectedPage element={Element} {...routeProps} />} />
              })}
              <Route key="/profile" path="/profile" exact element={<Profile />} />
              <Route key="/" path="/" exact element={<Navigate to="/heat-map" />} />
            </Route>
            <Route path="/admin" element={<AdminLayout />}>
              {adminRoutes.map(({ element: Element, path, roles, usertype, ...routeProps }) => {
                return <Route key={path} exact path={path} element={<ProtectedPage element={Element} {...routeProps} />} />
              })}
              <Route key="/admin/" path="/admin/" exact element={<Navigate to="/admin/users" />} />
            </Route>
            <Route key="/login" path="/login" element={<Login />} />
            <Route key="/logout" path="/logout" element={<Logout />} />
            <Route key="/not-found" path="/not-found" element={<NotFound />} />
            <Route key="/unauthorized" path="/unauthorized" element={<Unauthorized />} />
            <Route key="*" path="*" element={<Navigate to="/not-found" />} />
          </Routes>
          <GlobalLoading />
        </div>
      </BrowserRouter>
    </AppContext.Provider>
  )
}

export default App
